import React from "react";
import PropTypes from "prop-types";

const EmailPreview = ({ message }) => {
  return (
    <>
      <div dangerouslySetInnerHTML={{ __html: message }} />
    </>
  );
};
EmailPreview.propTypes = {
  message: PropTypes.string.isRequired,
  handleClose: PropTypes.func.isRequired,
};
export default EmailPreview;
